export class Marketplace {
    code: string
    title: string
    description: string
    id: string
    status: string
    type: string
    categories: MarketPlaceCategory[]

    constructor(model : Marketplace){
        this.code = model.code
        this.description = model.description || ''
        this.title = model.title
        this.id = model.id
        this.status = model.status
        this.type = model.type
        this.categories = model.categories
    }
}

export interface MarketPlaceCategory {
    id: string
    segmentationCode: string
    status: string
    title: string
}

export class MarketPlaceStandardFlow extends Marketplace{
    standardDictionaryName: string
    icon: string 
    color: string
    generalDescription: string

    constructor( model : MarketPlaceStandardFlow){
        super(model)
        this.icon = "fa fa-3x fa-rocket";
        this.color = "#31B9FF";
        this.standardDictionaryName = model.standardDictionaryName;
        this.generalDescription = "STANDARD_FLOW_GENERAL_DESC";
    }
}

export class MarketPlaceNonTransactionalFlow extends Marketplace{
    icon: string 
    color: string
    generalDescription: string

    constructor(model : MarketPlaceNonTransactionalFlow){
        super(model)
        this.icon = "fa fa-3x fa-file-code";
        this.color = "#F96565";
        this.generalDescription = "NON_TRANSACTIONAL_FLOW_GENERAL_DESC";
    }
}
export class MarketPlaceBusinessLogic extends Marketplace{
    configurationType: string
    icon: string 
    color: string
    generalDescription: string

    constructor(model : MarketPlaceBusinessLogic){
        super(model)
        this.icon = "fa fa-3x fa-money-bill";
        this.color = "#50D27B";
        this.configurationType = model.configurationType;
        this.generalDescription = "BUSINESS_LOGIC_GENERAL_DESC";
    }
}

export class MarketPlaceDataLogic extends Marketplace{
    configurationType: string
    integration: string
    icon: string 
    color: string
    generalDescription: string

    constructor(model : MarketPlaceDataLogic){
        super(model)
        this.icon = "fa fa-3x fa-database";
        this.color = "#B85483";
        this.configurationType = model.configurationType;
        this.integration = model.integration;
        this.generalDescription = "DATA_LOGIC_GENERAL_DESC";
    }
}

export class MarketPlaceChannelReportConfiguration extends Marketplace{
    standardDictionaryName: string
    isExternal: boolean
    icon: string 
    color: string
    generalDescription: string

    constructor(model : MarketPlaceChannelReportConfiguration){
        super(model)
        this.icon = "fa fa-3x fa-file-alt";
        this.color = "#F0F56D";
        this.standardDictionaryName = model.standardDictionaryName;
        this.isExternal = model.isExternal;
        this.generalDescription = "CHANNEL_REPORT_CONFIG_GENERAL_DESC";
    }
}

export class MarketPlaceStandardProductReport extends Marketplace{
    standardDictionaryName: string
    configurationType: string
    descriptionEXT: string
    icon: string 
    color: string
    generalDescription: string

    constructor(model : MarketPlaceStandardProductReport){
        super(model)
        this.icon = "fa fa-3x fa-file-pdf";
        this.color = "#0050C8";
        this.standardDictionaryName = model.standardDictionaryName;
        this.configurationType = model.configurationType;
        this.descriptionEXT = model.descriptionEXT;
        this.generalDescription = "STANDARD_PRODUCT_REPORT_GENERAL_DESC";
    }
}

export class MarketPlaceStandardProductEmail extends Marketplace{
    standardDictionaryName: string
    descriptionEXT: string
    ReportCodes: string[]
    configurationType: string
    icon: string 
    color: string
    generalDescription: string

    constructor(model : MarketPlaceStandardProductEmail){
        super(model)
        this.icon = "fa fa-3x fa-envelope";
        this.color = "#56565A";
        this.standardDictionaryName = model.standardDictionaryName;
        this.descriptionEXT = model.descriptionEXT;
        this.configurationType = model.configurationType;
        this.ReportCodes = model.ReportCodes;
        this.generalDescription = "STANDARD_PRODUCT_EMAIL_GENERAL_DESC";
    }
}

export class MarketPlaceViewEngine extends Marketplace{
    configuration: string
    icon: string 
    color: string
    generalDescription: string

    constructor(model : MarketPlaceViewEngine){
        super(model)
        this.icon = "fa fa-3x fa-cogs";
        this.color = "#FFB45E";
        this.configuration = model.configuration;
        this.generalDescription = "VIEW_ENGINE_GENERAL_DESC";
    }
}

export class MarketPlaceConnections extends Marketplace{
    icon: string 
    color: string
    generalDescription: string

    constructor(model : Marketplace){
        super(model)
        this.icon = "fa fa-3x fa-plug";
        this.color = "#B66DF5";
        this.generalDescription = "CONNECTION_GENERAL_DESC";
    }
}

export class MarketPlaceStandardDictionary extends Marketplace{
    icon: string 
    color: string
    generalDescription: string

    constructor(model : Marketplace){
        super(model)
        this.icon = "fa fa-3x fa-book";
        this.color = "#219E8D";
        this.generalDescription = "STANDARD_DICTONARY_GENERAL_DESC";
    }
}


// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/model/classes/marketplace.class.ts